import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import Scorecard from './Scorecard';
import { getPptData } from '../../Diagnose/actions';
import {
    selectAllGapDataFetched,
    selectCompSurveySetting,
    selectFiltersApplied,
    selectOverallView,
    selectPrevYear,
    selectResurveyAllGapData,
    selectResurveyAllGapDataFetched,
    selectResurveyData,
    selectResurveyDataFetched,
} from '../selector';
import { getMappingExcel, getInclusionDataResurvey, getAllGapData } from '../../Reports/actions';
import { getDefaultSettings } from '../../Login/selector';
import { setOverallView } from '../actions';

const stateToProps = createStructuredSelector({
    activeFilter: selectFiltersApplied(),
    defaultSettings: getDefaultSettings(),
    resurveyData: selectResurveyData(),
    resurveyDataFetched: selectResurveyDataFetched(),
    resurveyAllGapData: selectResurveyAllGapData(),
    resurveyAllGapDataFetched: selectResurveyAllGapDataFetched(),
    allGapDataFetched: selectAllGapDataFetched(),
    prevYear: selectPrevYear(),
    compSurveySetting: selectCompSurveySetting(),
    overallView: selectOverallView(),
});

const dispatchToProps = { getPptData, getMappingExcel, getInclusionDataResurvey, getAllGapData, setOverallView };

export default connect(stateToProps, dispatchToProps)(Scorecard);
